interface ErrorDetail {
  cell: string;
  errorType: string;
  formula?: string;
  message?: string;
}

interface EngineDiagnosticsProps {
  title: string;
  errors?: string[];
  errorCells?: string[];
  detailedErrors?: ErrorDetail[];
}

export function EngineDiagnostics({
  title,
  errors = [],
  errorCells = [],
  detailedErrors = [],
}: EngineDiagnosticsProps) {
  const hasErrors = errors.length > 0 || errorCells.length > 0;

  return (
    <div>
      <h3
        style={{
          fontSize: '1rem',
          fontWeight: 600,
          color: '#47331F',
          marginBottom: '0.75rem',
        }}
      >
        {title}
      </h3>
      <div
        style={{
          padding: '1rem',
          background: 'rgba(239, 235, 229, 0.5)',
          borderRadius: '6px',
        }}
      >
        {/* Structural Errors */}
        {errors.length > 0 && (
          <div style={{ marginBottom: errorCells.length > 0 ? '1rem' : 0 }}>
            <div
              style={{
                fontSize: '0.875rem',
                fontWeight: 500,
                marginBottom: '0.5rem',
              }}
            >
              Structural Errors ({errors.length}):
            </div>
            <ul
              style={{
                margin: '0.5rem 0',
                paddingLeft: '1.5rem',
                fontSize: '0.875rem',
                color: '#991b1b',
              }}
            >
              {errors.map((err, i) => (
                <li key={i}>{err}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Error Cells with Details */}
        {errorCells.length > 0 && (
          <div>
            <div
              style={{
                fontSize: '0.875rem',
                fontWeight: 500,
                marginBottom: '0.5rem',
              }}
            >
              Error Cells ({errorCells.length}):
            </div>
            {detailedErrors.length > 0 ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.75rem',
                }}
              >
                {detailedErrors.map((err, i) => (
                  <div
                    key={i}
                    style={{
                      padding: '0.75rem',
                      background: 'rgba(153, 27, 27, 0.05)',
                      borderLeft: '3px solid #991b1b',
                      borderRadius: '4px',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        color: '#991b1b',
                        marginBottom: '0.25rem',
                      }}
                    >
                      ❌ {err.cell}: {err.errorType}
                    </div>
                    {err.formula && (
                      <div
                        style={{
                          fontSize: '0.8125rem',
                          color: '#666',
                          fontFamily: 'monospace',
                          marginBottom: '0.25rem',
                        }}
                      >
                        Formula: {err.formula}
                      </div>
                    )}
                    {err.message && (
                      <div
                        style={{
                          fontSize: '0.8125rem',
                          color: '#666',
                          fontStyle: 'italic',
                        }}
                      >
                        Reason: {err.message}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize: '0.875rem', color: '#991b1b' }}>
                {errorCells.join(', ')}
              </div>
            )}
          </div>
        )}

        {/* No errors message */}
        {!hasErrors && (
          <div style={{ fontSize: '0.875rem', color: '#10b981' }}>
            ✓ No errors found
          </div>
        )}
      </div>
    </div>
  );
}
